import Header from "../Header";
import Footer from "../Footer";
import Breadcrumbs from "../Breadcrumbs";
import BannerImg from "../assets/Images/banner2-1920x450.png";
import BottomLogoImg from "../assets/Images/bottom-logo.png";
import MainImg from "../assets/Images/fees2.png";
import TitleImg from "../assets/Images/title.png";
import ImageTextLayout from "../shared/ImageTextLayout";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./MediationFeesPage.scss";

const MediationFeesPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <div className="banner">
        <img src={BannerImg} alt="" />
        <div className="banner_title res">
          <h1 className="banner-main-title">{t("fees_page_header")}</h1>
          <p className="banner-subtitle">{t("fees_page_header2")}</p>
        </div>
      </div>
      <Breadcrumbs>
        <Link>{t("breadcrumbs_fees_page_link1")}</Link>
        <span>{t("breadcrumbs_fees_page_span")}</span>
        <Link>{t("breadcrumbs_fees_page_link2")}</Link>
      </Breadcrumbs>
      <ImageTextLayout
        image={MainImg}
        imageAlt="Mediation Fees"
        titleIcon={TitleImg}
        title={t("fees_page_h2")}
      >
        <p>{t("fees_page_text1")}</p>
        <p>{t("fees_page_text2")}</p>
        <p>{t("fees_page_text3")}</p>
      </ImageTextLayout>
      <div className="temporary">
        <img id="res-img" src={BottomLogoImg} alt="" />
      </div>

      <Footer />
    </>
  );
};

export default MediationFeesPage;
